/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.3.0-nightly.2026.6.2",
    versionName: "0.3.0-nightly.2026.6.2",
    versionChannel: "nightly",
    buildDate: "2026-06-02T00:41:52.783Z",
    commitHash: "ddeae4f5dae9d9121144608cbe3844e6214798dc",
};
